import PropTypes from 'prop-types';
import React, {useEffect, useState, useMemo} from 'react';
import {Helmet} from 'react-helmet';
import {Chip, Grid, Toolbar, Typography} from '@material-ui/core';
import {debounce} from 'throttle-debounce';
import {convertToObjectByKey} from '@ozgene/gp5.utils.array-functions';
import ImportedProcedureList from 'ImportedProcedureLobby/components/ImportedProcedureList';
import Loader from 'util/Loader';
import ImportedProcedureProperties from 'ImportedProcedureLobby/components/ImportedProcedureProperties';
import {findImportedProcedures} from 'Projects/service/ProjectService';

export default function ImportedProcedureLobbyView(props, context) {
  const {router} = context;
  const {
    location: {
      query: {procedureFilterText = '', milestoneFilterText = ''},
    },
  } = props;
  const decodedProcedureFilterText = decodeURIComponent(procedureFilterText);
  const decodedMilestoneFilterText = decodeURIComponent(milestoneFilterText);
  const [isLoading, setIsLoading] = useState(true);
  const [importedProcedures, setImportedProcedures] = useState([]);
  const [selectedProcedureId, setSelectedProcedureId] = useState();
  const proceduresById = useMemo(
    () => convertToObjectByKey(importedProcedures, 'id'),
    [importedProcedures],
  );
  const selectedProcedure = useMemo(
    () => proceduresById[selectedProcedureId],
    [selectedProcedureId, proceduresById],
  );
  const handleSelectionChange = (selection) => {
    if (!!selection && selection.length > 0) {
      setSelectedProcedureId(selection[selection.length - 1]);
    } else {
      setSelectedProcedureId();
    }
  };
  const handleChangeProcedureFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.procedureFilterText = encodeURIComponent(filterText);
    } else {
      delete query.procedureFilterText;
    }

    router.replace({pathname, query});
  });
  const handleChangeMilestoneFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.milestoneFilterText = encodeURIComponent(filterText);
    } else {
      delete query.milestoneFilterText;
    }

    router.replace({pathname, query});
  });

  useEffect(() => {
    const handleRetrieveProcedures = async () => {
      setImportedProcedures(await findImportedProcedures());
      setIsLoading(false);
    };

    if (isLoading && importedProcedures.length === 0) {
      handleRetrieveProcedures();
    }
  }, [isLoading, importedProcedures]);

  return (
    <>
      <Helmet title="Procedures" defer={false} />
      <Grid container spacing={2}>
        <Grid item xs={8} md={9}>
          <Toolbar>
            <Typography style={{color: 'grey'}} variant="h5">
              Procedure Lobby
            </Typography>
            <Chip style={{marginLeft: 30}} variant="outlined" label={importedProcedures.length} />
          </Toolbar>
          {isLoading ? (
            <Loader label="Loading Procedures..." />
          ) : (
            <ImportedProcedureList
              procedures={importedProcedures}
              onSelectionChange={handleSelectionChange}
              procedureFilterText={decodedProcedureFilterText}
              milestoneFilterText={decodedMilestoneFilterText}
              onChangeProcedureFilterText={handleChangeProcedureFilterText}
              onChangeMilestoneFilterText={handleChangeMilestoneFilterText}
              selectedId={selectedProcedureId}
            />
          )}
        </Grid>
        {!isLoading && (
          <Grid item xs={4} md={3}>
            <ImportedProcedureProperties selectedProcedure={selectedProcedure} />
          </Grid>
        )}
      </Grid>
    </>
  );
}

ImportedProcedureLobbyView.propTypes = {
  location: PropTypes.object.isRequired,
};

ImportedProcedureLobbyView.contextTypes = {
  router: PropTypes.object.isRequired,
};

ImportedProcedureLobbyView.defaultProps = {
  params: null,
};
